import React, { Component } from 'react';

class DashboardErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
      showDetails: false,
      copied: false
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[DashboardErrorBoundary] Error capturado en pantalla:', error, errorInfo);
    this.setState({ errorInfo });
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null, errorInfo: null, showDetails: false });
  };

  handleGoHome = () => {
    this.setState({ hasError: false, error: null, errorInfo: null, showDetails: false });
    window.location.href = '/dashboard';
  };

  handleCopyError = () => {
    const errorText = `[Error Vortex Web]\nMensaje: ${this.state.error?.message || 'Desconocido'}\nURL: ${window.location.href}\nFecha: ${new Date().toISOString()}\nStack:\n${this.state.error?.stack || ''}\nComponent Stack:\n${this.state.errorInfo?.componentStack || ''}`;
    navigator.clipboard.writeText(errorText).then(() => {
      this.setState({ copied: true });
      setTimeout(() => this.setState({ copied: false }), 2500);
    });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '60vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '2rem 1rem'
        }}>
          <div style={{
            maxWidth: '680px',
            width: '100%',
            background: 'linear-gradient(135deg, rgba(20, 10, 15, 0.95) 0%, rgba(10, 20, 35, 0.95) 100%)',
            border: '1px solid rgba(239, 68, 68, 0.4)',
            borderRadius: '16px',
            padding: '2.5rem 2rem',
            boxShadow: '0 20px 50px rgba(0, 0, 0, 0.7), 0 0 30px rgba(239, 68, 68, 0.15)',
            color: '#f8fafc',
            textAlign: 'center',
            fontFamily: "'Inter', sans-serif"
          }}>
            <div style={{
              width: '64px',
              height: '64px',
              margin: '0 auto 1.5rem',
              borderRadius: '50%',
              background: 'rgba(239, 68, 68, 0.15)',
              border: '2px solid rgba(239, 68, 68, 0.4)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '2rem'
            }}>
              ⚠️
            </div>

            <h2 style={{
              fontSize: '1.4rem',
              fontWeight: 700,
              color: '#f87171',
              margin: '0 0 0.5rem 0',
              fontFamily: "'Orbitron', sans-serif",
              letterSpacing: '1px'
            }}>
              Error al renderizar esta pantalla
            </h2>

            <p style={{
              color: '#cbd5e1',
              fontSize: '0.92rem',
              lineHeight: 1.6,
              margin: '0 0 1.5rem 0'
            }}>
              Ocurrió un problema inesperado al cargar este módulo. La aplicación sigue funcionando y tu sesión está segura.
            </p>

            {this.state.error && (
              <div style={{
                background: 'rgba(0, 0, 0, 0.4)',
                border: '1px solid rgba(239, 68, 68, 0.25)',
                borderRadius: '8px',
                padding: '0.85rem 1rem',
                textAlign: 'left',
                margin: '0 0 1.5rem 0',
                fontSize: '0.85rem',
                color: '#fca5a5',
                fontFamily: 'monospace',
                overflowX: 'auto',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word'
              }}>
                <strong>Error:</strong> {this.state.error.toString()}
              </div>
            )}

            <div style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '0.75rem',
              justifyContent: 'center',
              marginBottom: '1.5rem'
            }}>
              <button
                onClick={this.handleRetry}
                style={{
                  background: 'linear-gradient(135deg, #ef4444 0%, #b91c1c 100%)',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '10px 20px',
                  fontWeight: 600,
                  fontSize: '0.9rem',
                  cursor: 'pointer',
                  boxShadow: '0 4px 14px rgba(239, 68, 68, 0.3)',
                  transition: 'all 0.2s'
                }}
              >
                🔄 Reintentar
              </button>

              <button
                onClick={this.handleGoHome}
                style={{
                  background: 'rgba(255, 255, 255, 0.08)',
                  color: '#e2e8f0',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  borderRadius: '8px',
                  padding: '10px 20px',
                  fontWeight: 600,
                  fontSize: '0.9rem',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
              >
                🏠 Ir al Inicio
              </button>

              <button
                onClick={this.handleCopyError}
                style={{
                  background: 'transparent',
                  color: this.state.copied ? '#4ade80' : '#94a3b8',
                  border: '1px solid rgba(148, 163, 184, 0.3)',
                  borderRadius: '8px',
                  padding: '10px 16px',
                  fontSize: '0.85rem',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
              >
                {this.state.copied ? '✓ Reporte Copiado' : '📋 Copiar Detalle'}
              </button>

              <button
                onClick={() => this.setState(prev => ({ showDetails: !prev.showDetails }))}
                style={{
                  background: 'transparent',
                  color: '#38bdf8',
                  border: 'none',
                  padding: '10px 12px',
                  fontSize: '0.85rem',
                  cursor: 'pointer',
                  textDecoration: 'underline'
                }}
              >
                {this.state.showDetails ? 'Ocultar Stack' : 'Ver Stack Técnico'}
              </button>
            </div>

            {this.state.showDetails && (
              <div style={{
                textAlign: 'left',
                background: 'rgba(0, 0, 0, 0.6)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: '8px',
                padding: '1rem',
                maxHeight: '220px',
                overflowY: 'auto',
                fontSize: '0.75rem',
                color: '#94a3b8',
                fontFamily: 'monospace',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word'
              }}>
                <div style={{ color: '#f87171', marginBottom: '0.5rem', fontWeight: 'bold' }}>Stack Trace:</div>
                {this.state.error?.stack}
                {this.state.errorInfo?.componentStack && (
                  <>
                    <div style={{ color: '#38bdf8', margin: '0.5rem 0', fontWeight: 'bold' }}>Component Tree:</div>
                    {this.state.errorInfo.componentStack}
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default DashboardErrorBoundary;
